import { attachApiRequestTelemetry } from "../observability/apiRequestTelemetry.js";
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

attachApiRequestTelemetry(axiosInstance);

const getApiBaseUrl = () =>
  (axiosInstance.defaults.baseURL || "").replace(/\/+$/, "");

const resolveApiUrl = (path = "") => {
  if (!path || /^https?:\/\//i.test(path)) {
    return path;
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const apiBaseUrl = getApiBaseUrl();

  return apiBaseUrl ? `${apiBaseUrl}${normalizedPath}` : normalizedPath;
};

export { axiosInstance, resolveApiUrl };
